import MainLayout from "screens/partials/layout";
import StorboltMetaAdsComponent from "screens/partials/meta-ads";

export default function MetaAds() {
    return (
        <MainLayout>
            <StorboltMetaAdsComponent />
        </MainLayout>
    )
}
